import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/legacy/types'
import { EmptyAuthPropsFactory, IAuthProps } from '@/entities/Auth'
import { IUserProps } from '@/entities/Legacy/User'

export default class LegacyRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  logout() {
    this.auth = null
  }

  set auth(value: IAuthProps | null) {
    if (value) {
      // トークンの利用可能時間を保存
      const date = new Date().getTime() + 1000 * 60 * Number(value.expired)
      this.cookies.set(process.env.APP_NAME + '_legacy_accessToken', value.accessToken, {
        path: '/',
        maxAge: 60 * 60 * 24 * 14
      }) // 2週間
      this.cookies.set(process.env.APP_NAME + '_legacy_tokenType', value.tokenType, { path: '/', maxAge: 60 * 60 * 24 * 14 }) // 2週間
      this.cookies.set(process.env.APP_NAME + '_legacy_expired', date, { path: '/', maxAge: 60 * 60 * 24 * 14 }) // 2週間
    } else {
      this.cookies.remove(process.env.APP_NAME + '_legacy_accessToken', { path: '/', maxAge: 1 })
      this.cookies.remove(process.env.APP_NAME + '_legacy_tokenType', { path: '/', maxAge: 1 })
      this.cookies.remove(process.env.APP_NAME + '_legacy_expired', { path: '/', maxAge: 1 })
    }
  }

  get auth(): IAuthProps | null {
    return EmptyAuthPropsFactory({
      accessToken: this.cookies.get(process.env.APP_NAME + '_legacy_accessToken'),
      tokenType: this.cookies.get(process.env.APP_NAME + '_legacy_tokenType'),
      expired: this.cookies.get(process.env.APP_NAME + '_legacy_expired')
    })
  }

  get token(): string {
    return this.cookies.get(process.env.APP_NAME + '_legacy_accessToken')
  }

  get expired(): number {
    return Number(this.cookies.get(process.env.APP_NAME + '_legacy_expired'))
  }

  set user(value: IUserProps | null) {
    this.store.commit(new types.User(value))
  }

  get user(): IUserProps | null {
    return this.store.state.legacy.user
  }
}
